import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import './i18n/config.ts'

// Hide loading spinner when React app is ready
const hideLoadingSpinner = () => {
  const spinner = document.getElementById('loading-spinner')
  if (spinner) {
    spinner.style.opacity = '0'
    spinner.style.transition = 'opacity 0.5s ease-out'
    setTimeout(() => {
      spinner.style.display = 'none'
    }, 500)
  }
}

// Render the app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)

// Hide spinner after React has mounted
setTimeout(hideLoadingSpinner, 300)

// Global image protection - prevent right-click and screenshot attempts
if (typeof window !== 'undefined') {
  // Prevent right-click context menu on images
  document.addEventListener('contextmenu', (e) => {
    const target = e.target as HTMLElement
    if (target.tagName === 'IMG') {
      e.preventDefault()
      return false
    }
  }, false)

  // Prevent drag and drop of images
  document.addEventListener('dragstart', (e) => {
    const target = e.target as HTMLElement
    if (target.tagName === 'IMG') {
      e.preventDefault()
      return false
    }
  }, false)

  // Prevent image selection
  document.addEventListener('selectstart', (e) => {
    const target = e.target as HTMLElement
    if (target.tagName === 'IMG') {
      e.preventDefault()
      return false
    }
  }, false)

  // Disable common screenshot keyboard shortcuts (F12, Ctrl+Shift+I, Ctrl+U, etc.)
  document.addEventListener('keydown', (e) => {
    // Disable F12 (Developer Tools)
    if (e.key === 'F12') {
      e.preventDefault()
      return false
    }
    // Disable Ctrl+Shift+I (Developer Tools)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault()
      return false
    }
    // Disable Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault()
      return false
    }
    // Disable Ctrl+U (View Source)
    if (e.ctrlKey && e.key === 'U') {
      e.preventDefault()
      return false
    }
    // Disable Ctrl+S (Save Page)
    if (e.ctrlKey && e.key === 'S') {
      e.preventDefault()
      return false
    }
  }, false)

  // Disable print screen (limited effectiveness)
  document.addEventListener('keyup', (e) => {
    if (e.key === 'PrintScreen') {
      navigator.clipboard.writeText('')
    }
  }, false)
}
